let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.error || `HTTP ${status}`)
    this.status = status
    this.body = body
  }
}

export function setCsrfToken(token) {
  if (token) csrfToken = token
}

export async function api(method, path, body) {
  const res = await fetch(path, {
    method,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken },
    body: body === undefined ? undefined : JSON.stringify(body),
    credentials: 'same-origin',
  })
  const json = res.status === 204 ? null : await res.json().catch(() => null)
  if (!res.ok) throw new ApiError(res.status, json)
  if (json?.csrf_token) setCsrfToken(json.csrf_token)
  return json
}

export const get = (path) => api('GET', path)
export const post = (path, body) => api('POST', path, body)
export const patch = (path, body) => api('PATCH', path, body)
export const del = (path) => api('DELETE', path)
